<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Download Holdings {{ data?.type === 'excel' ? 'Excel' : 'PDF' }}</h2>
  </div>

  <div class="dialog-content">
    <p class="dialog-subtitle">Select language for the holdings report:</p>
    <mat-radio-group [(ngModel)]="selectedLanguage" class="language-radio-group">
      <div
        class="language-card"
        [class.selected]="selectedLanguage === 'ar'"
        (click)="selectedLanguage = 'ar'">
        <mat-radio-button value="ar">
          <div class="language-card-info">
            <span class="language-name">العربية</span>
            <span class="language-code">(Arabic)</span>
          </div>
        </mat-radio-button>
      </div>

      <div
        class="language-card"
        [class.selected]="selectedLanguage === 'en'"
        (click)="selectedLanguage = 'en'">
        <mat-radio-button value="en">
          <div class="language-card-info">
            <span class="language-name">English</span>
            <span class="language-code">(الإنجليزية)</span>
          </div>
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </div>

  <div class="dialog-actions">
    <button type="button" class="btn cancel_large_btn" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="btn primary_large_btn" (click)="download()" [disabled]="!selectedLanguage">
      Download
    </button>
  </div>
</div>

